import React from 'react';
import { getResearchTypeIcon } from '@/components/shared/research-utils';
import { formatResearchType } from '@/components/text-content-lightbox/utils/research-parameters-utils';

interface ResearchTypeDisplaySectionProps {
  researchType?: string;
}

export const ResearchTypeDisplaySection: React.FC<ResearchTypeDisplaySectionProps> = ({ 
  researchType 
}) => {
  if (!researchType) return null;

  const formattedResearchType = formatResearchType(researchType);

  return (
    <div className="p-3 md:p-4 rounded-2xl bg-gradient-to-r from-gray-50 to-slate-50 dark:from-gray-900/20 dark:to-slate-900/20 border border-gray-200 dark:border-gray-700">
      <div className="flex items-center gap-2 mb-1">
        {getResearchTypeIcon(formattedResearchType)}
        <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">
          Research Type
        </h3>
      </div>
      <div className="text-sm font-medium text-gray-600 dark:text-gray-400">
        {formattedResearchType}
      </div>
    </div>
  );
}; 